"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowRight, PhoneCall, CircleCheck as CheckCircle2, ShieldCheck, Award } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const benefits = [{
  id: 1,
  title: "Representante exclusivo",
  desc: "Spraying Systems Co. em Portugal desde 1993."
}, {
  id: 2,
  title: "Suporte técnico especializado",
  desc: "Engenharia de precisão para máxima eficiência e poupança."
}, {
  id: 3,
  title: "Soluções à medida",
  desc: "Projetos customizados para qualquer setor industrial."
}];
export default function CallToAction() {
  const shouldReduceMotion = useReducedMotion();
  const initialMotion = shouldReduceMotion ? {
    opacity: 1,
    y: 0
  } : {
    opacity: 0,
    y: 20
  };
  const inViewMotion = {
    opacity: 1,
    y: 0
  };
  return <section id="calltoaction" data-nav="light" className="relative overflow-hidden bg-background py-20 md:py-28">
      {/* Subtle background decoration */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 -z-10 bg-[radial-gradient(ellipse_60%_50%_at_50%_100%,hsl(215_90%_45%/0.08),transparent)]" />

      <div className="container mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <motion.div initial={initialMotion} whileInView={inViewMotion} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.5,
        ease: "easeOut"
      }} className="relative overflow-hidden rounded-3xl border border-border bg-card p-8 shadow-xl md:p-14 lg:p-16">
          {/* Accent corner visual */}
          <div aria-hidden="true" className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full bg-secondary/10 blur-3xl" />

          <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12 lg:gap-12">
            {/* Left: Main message */}
            <div className="space-y-6 lg:col-span-7">
              <div className="inline-flex items-center gap-2 rounded-full border border-border bg-muted/60 px-3.5 py-1.5 text-xs font-medium text-muted-foreground">
                <ShieldCheck className="size-4 text-secondary" />
                <span>Eurocontrol &bull; Engenharia & Pulverização</span>
              </div>

              <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl lg:text-5xl font-default">
                Otimize os seus processos de pulverização industrial
              </h2>

              <p className="text-base leading-relaxed text-muted-foreground sm:text-lg">
                Fale com a nossa equipa técnica para avaliar a sua aplicação e encontrar a solução exata com maior precisão e menor consumo de recursos.
              </p>

              {/* Action Buttons */}
              <div className="flex flex-wrap items-center gap-4 pt-2">
                <Button asChild size="lg" className="rounded-xl bg-primary px-7 py-6 text-base font-semibold text-primary-foreground shadow-md transition-[background-color,box-shadow] hover:bg-primary/90">
                  <Link to="/ContactsPage">
                    <span>Solicite um orçamento</span>
                    <ArrowRight className="size-5" />
                  </Link>
                </Button>

                <Button asChild variant="outline" size="lg" className="rounded-xl border-border bg-background px-6 py-6 text-base font-medium text-foreground transition-colors hover:bg-muted/50">
                  <Link to="/ProductsPage">
                    <span>Ver catálogo de produtos</span>
                  </Link>
                </Button>
              </div>
            </div>

            {/* Right: Key Highlights card list */}
            <div className="space-y-4 rounded-2xl border border-border bg-muted/30 p-6 lg:col-span-5 sm:p-8">
              <div className="flex items-center gap-3 border-b border-border/80 pb-4">
                <div className="flex size-10 items-center justify-center rounded-xl bg-secondary/15 text-secondary">
                  <Award className="size-5" />
                </div>
                <div>
                  <h3 className="text-base font-semibold text-foreground font-default">
                    Garantia de Qualidade
                  </h3>
                  <p className="text-xs text-muted-foreground">
                    Tecnologia líder mundial em pulverização
                  </p>
                </div>
              </div>

              <div className="space-y-4 pt-2">
                {benefits.map((item, i) => <div key={item.id} data-index={i} className="flex items-start gap-3">
                    <CheckCircle2 className="mt-0.5 size-5 shrink-0 text-secondary" />
                    <div>
                      <h4 className="text-sm font-semibold text-foreground font-default">
                        {item.title}
                      </h4>
                      <p className="text-xs text-muted-foreground leading-relaxed">
                        {item.desc}
                      </p>
                    </div>
                  </div>)}
              </div>

              <div className="mt-4 rounded-xl bg-card p-4 border border-border text-xs text-muted-foreground flex items-center justify-between">
                <span className="flex items-center gap-2 font-medium text-foreground">
                  <PhoneCall className="size-4 text-secondary" />
                  Atendimento direto
                </span>
                <span>Resposta em 24h úteis</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}